import { render, staticRenderFns } from "./StructureViewerThumbnail.vue?vue&type=template&id=c72fe0ea&scoped=true"
import script from "./StructureViewerThumbnail.vue?vue&type=script&lang=js"
export * from "./StructureViewerThumbnail.vue?vue&type=script&lang=js"
import style0 from "./StructureViewerThumbnail.vue?vue&type=style&index=0&id=c72fe0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72fe0ea",
  null
  
)

export default component.exports